import { render } from "./StarRating.vue?vue&type=template&id=23426089&scoped=true&ts=true"
import script from "./StarRating.vue?vue&type=script&lang=ts"
export * from "./StarRating.vue?vue&type=script&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=23426089&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23426089"]])

export default __exports__